import * as Globals from "../../globals";
import {BoxGeometry, Mesh} from "three";
import {degrees90} from "../../constants/mathConstants";
import {pillarMaterial} from "../../constants/materialConstants";
import {buildingGroup} from "../../main";
import {addEdgeGeometry} from "../../utils/threeUtils";
import {pillarMeshName} from "../../constants/nameConstants";
import {setObjectLayer} from "../../utils/layerUtils";
import {getVolume} from "../../utils/volumeUtils";

export class Pillar {
    constructor(pillarPreview, automaticallyPlaced = false) {
        this.pillarPreview = pillarPreview;
        this.width = this.pillarPreview.width;
        this.depth = this.pillarPreview.depth;
        this.height = this.pillarPreview.height;
        this.pillarMesh = null;
        this.automaticallyPlaced = automaticallyPlaced;
    }

    create() {
        let pillarGeometry = new BoxGeometry(this.pillarPreview.width, this.pillarPreview.depth, this.pillarPreview.height);
        pillarGeometry.rotateX(degrees90); //Rotieren um auf x/z zu liegen
        this.pillarMesh = new Mesh(pillarGeometry, pillarMaterial);
        this.pillarMesh.name = pillarMeshName;
        this.pillarMesh.position.copy(this.pillarPreview.previewMesh.position);
        this.pillarMesh.position.y = this.height / 2;
        addEdgeGeometry(this.pillarMesh);
        setObjectLayer(this.pillarMesh, Globals.layers.pillars, true);
        buildingGroup.addWithUuid(this.pillarMesh);
        this.setUserData();
        return this.pillarMesh;
    }

    setUserData() {
        if (this.pillarMesh === null) {
            console.error("Cant set userData of pillar. Element is null");
            return;
        }

        this.pillarMesh.userData = {
            width: this.width,
            depth: this.depth,
            height: this.height,
            originalVolume: getVolume(this.pillarMesh.geometry),
            automaticallyPlaced: this.automaticallyPlaced
        };
    }
}
